var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14642E",
    d: "M43.541 15.653v1.8H0v-1.8a9.05 9.05 0 0 1 9.05-9.05h1.802V4.8c0-.99.81-1.801 1.8-1.801.991 0 1.802.81 1.802 1.801v1.801h14.499v-1.8c0-.992.81-1.802 1.8-1.802.991 0 1.802.81 1.802 1.801v1.801h1.8c5.134-.045 9.186 4.008 9.186 9.05m-22.963 16.3c0-5.134 3.061-9.726 6.799-12.698H0V35.6a9.05 9.05 0 0 0 9.05 9.05h18.282c-3.693-2.972-6.754-7.564-6.754-12.697"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3DC869",
    d: "M48.002 31.95c0 7.025-5.719 12.698-12.698 12.698-7.024 0-12.698-5.718-12.698-12.698 0-6.979 5.719-12.697 12.698-12.697 6.98 0 12.698 5.718 12.698 12.698"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8,
    d: "M35.257 26.506v5.223l3.647 3.872"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgCalendar;